import { render, staticRenderFns } from "./CompleteQB.vue?vue&type=template&id=42b8798f"
import script from "./CompleteQB.vue?vue&type=script&lang=js"
export * from "./CompleteQB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports